import * as React from 'react';
import { Route } from 'react-router-dom';
import { Router } from 'react-router';
import PageNotFound from '../components/PageNotFound';
import FragmentSupportingSwitch from '../components/FragmentSupportingSwitch';
import * as RoutesModule from './loginRoutes';
import { createBrowserHistory } from 'history';
import VisuallyHiddenAnnouncement from 'VisuallyHiddenAnnouncement';

const routes = RoutesModule.routes;
const browserHistory = (window as any).browserHistory || createBrowserHistory();

if (!(window as any).browserHistory) {
	(window as any).browserHistory = browserHistory;
}

class LoginApp extends React.Component<any> {
	public render() {
		return (
			<Router history={browserHistory}>
				<VisuallyHiddenAnnouncement>
					<FragmentSupportingSwitch>
						{routes}
						<Route component={PageNotFound} />
					</FragmentSupportingSwitch>
				</VisuallyHiddenAnnouncement>
			</Router>
		);
	}
}

export default LoginApp;
